export const BASE_URL = "https://hjp.phoenix.yomagroup.io";


export const END_POINT_REQUISITION = `${BASE_URL}/requisitions`;
export const END_POINT_GET_REQUISITIONS = `${BASE_URL}/requisitions`;
export const END_POINT_APPROVE_REQUISITIONS = `${BASE_URL}/requisitions/update/`;
export const END_POINT_LOGIN = `${BASE_URL}/admins/login`;
export const END_POINT_ENTITIES = `${BASE_URL}/entities`;
export const END_POINT_CVS = `${BASE_URL}/cvs`;
export const END_POINT_CVS_DETAIL = `${BASE_URL}/cvs/`;
export const END_POINT_JOBS = `${BASE_URL}/jobs`;
export const END_POINT_JOB_DETAIL = `${BASE_URL}/jobs/`;
export const END_POINT_UPLOAD_FILE = `${BASE_URL}/upload`;

export const END_POINT_GET_JOB_CATEGORIES = `${BASE_URL}/jobs/categories`;
export const END_POINT_GET_ENTITIES = `${BASE_URL}/entities`;
